export type { RealtimeDataService } from './realtime-data.service'
export { RealtimeDataModule } from './realtime-data.module'
